import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'

import AdminGroupCard from 'module/admin-accessbility/AdminGroupCard'
import GeneratedGroupCard from 'module/admin-accessbility/GeneratedGroupCard'
import CustomGroupCard from 'module/admin-accessbility/CustomGroupCard'
import AddAdminModal from 'module/admin-accessbility/AddAdminModal'
import AddCustomGroupModal from 'module/admin-accessbility/AddCustomGroupModal'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'

import {
  getApproverGroup,
  getAllAdmins,
  getApproverGroupStaff,
} from 'services/api/admin-accessibility'
import { useQuery } from 'react-query'
import AdxButton from 'components/custom/AdxButton'

const AdminAccessibility = () => {
  const [showAddAdminModal, setShowAddAdminModal] = useState(false)
  const [selectedAdminCardId, setSelectedAdminCardId] = useState(null)
  const [selectedAdminItem, setSelectedAdminItem] = useState({})

  const [showAddCustomGroupModal, setShowAddCustomGroupModal] = useState(false)
  const [selectedCustomCardId, setSelectedCustomCardId] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})

  const [disableInput, setDisableInput] = useState(false)

  const [dropDown, setDropDown] = useState([])

  const approverGroupList = useQuery('approverGroupList', async () => {
    const { data } = await getApproverGroup()
    return data
  })

  const allAdminsList = useQuery('allAdminsList', async () => {
    const { data } = await getAllAdmins()
    return data
  })

  const approverGroupStaffList = useQuery('approverGroupStaffList', async () => {
    const { data } = await getApproverGroupStaff()
    return data
  })

  const handleOpenAddAdminModal = () => {
    setShowAddAdminModal(true)
  }
  const handleCloseAddAdminModal = () => {
    setShowAddAdminModal(false)
    setSelectedAdminCardId(null)
    setSelectedAdminItem({})
  }

  const handleClickManageAdminCard = (item) => {
    handleOpenAddAdminModal()
    setSelectedAdminItem(item)
    setSelectedAdminCardId(item.staff_id)
  }

  const handleOpenAddCustomGroupModal = () => {
    setShowAddCustomGroupModal(true)
    setDropDown(approverGroupStaffList?.data)
  }
  const handleCloseAddCustomGroupModal = () => {
    setShowAddCustomGroupModal(false)
    setSelectedCustomCardId(null)
    setSelectedItem({})
    setDisableInput(false)
  }

  const handleClickManageCustomCard = (item) => {
    handleOpenAddCustomGroupModal()
    setSelectedCustomCardId(item.id)
    setSelectedItem(item)
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* <p>selectedCustomCardId <pre>{JSON.stringify(selectedCustomCardId,null,4)}</pre></p> */}
        <Box px={{ xs: 2, lg: 0 }} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4" fontWeight="bold">
              Company and staff management admins
            </Typography>
            <Typography variant="body1" color="light-gray-text.main">
              Assign admins to manage company & staff information.
            </Typography>
          </Box>
          <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
            <Box>
              {allAdminsList?.isLoading ? (
                <AdminGroupCard />
              ) : (
                allAdminsList?.data?.map((item, index) => (
                  <AdminGroupCard
                    item={item}
                    handleOpenAddAdminModal={() => handleClickManageAdminCard(item)}
                    keyIndex={index}
                    totalItems={allAdminsList?.data?.length}
                    sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
                  />
                ))
              )}
            </Box>
            <Box p={0.5}>
              <AdxButton
                variant={'ghost'}
                sx={{
                  pl: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  gap: 1,
                }}
                onClick={() => handleOpenAddAdminModal()}
              >
                <AddIcon color="alternate.main" />
                <Typography fontWeight={500} color="alternate.main">
                  Add an admin
                </Typography>
              </AdxButton>
            </Box>
          </Box>
        </Box>
        <Box px={{ xs: 2, lg: 0 }} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4" fontWeight="bold">
              Approver groups
            </Typography>
            <Typography variant="body1" color="light-gray-text.main">
              People or groups that can be selected as approvers in leave and claim approval flows.
            </Typography>
          </Box>
          <Box
            sx={{
              border: 1,
              borderRadius: '4.5px',
              borderColor: 'gray-line.main',
            }}
          >
            <Box
              sx={{
                borderBottom: 1,
                borderBottomColor: 'gray-line.main',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 2,
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }} variant="subtitle1">
                Built-in groups
              </Typography>
              <AdxInfoIcon toolTipTitle="Auto-created approver groups based on company hierarchy and reporting structure." />
            </Box>
            <Box>
              {approverGroupList?.isLoading ? (
                <GeneratedGroupCard item={{}} />
              ) : (
                approverGroupList?.data
                  ?.filter((item) => item.auto_generated)
                  .map((item, index) => (
                    <GeneratedGroupCard
                      item={item}
                      index={index}
                      length={approverGroupList?.data?.filter((item) => item.auto_generated).length}
                      handleClickManageCustomCard={() => {
                        setDisableInput(true)
                        handleClickManageCustomCard(item)
                      }}
                    />
                  ))
              )}
            </Box>
          </Box>
        </Box>
        <Box px={{ xs: 2, lg: 0 }}>
          <Box
            bgcolor="white.main"
            sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}
          >
            <Box
              sx={{
                borderBottom: 1,
                borderBottomColor: 'gray-line.main',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 2,
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }} variant="subtitle1">
                Custom groups
              </Typography>
              <AdxInfoIcon
                toolTipTitle="Manually created approver groups for teams such as HR, Finance, or management."
                sxToolTip={{ backgroundColor: 'red' }}
              />
            </Box>
            <Box>
              {approverGroupList?.isLoading ? (
                <CustomGroupCard item={{}} />
              ) : (
                approverGroupList?.data
                  ?.filter((item) => !item.auto_generated)
                  .map((item) => (
                    <CustomGroupCard
                      item={item}
                      handleClickManageCustomCard={() => handleClickManageCustomCard(item)}
                    />
                  ))
              )}
              <Box p={0.5}>
                <AdxButton
                  variant={'ghost'}
                  sx={{
                    pl: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    gap: 1,
                  }}
                  onClick={() => handleOpenAddCustomGroupModal()}
                >
                  <AddIcon color="alternate.main" />
                  <Typography fontWeight={500} color="alternate.main">
                    Add approver group
                  </Typography>
                </AdxButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <AddAdminModal
        showAddAdminModal={showAddAdminModal}
        handleCloseAddAdminModal={handleCloseAddAdminModal}
        selectedAdminCardId={selectedAdminCardId}
        selectedAdminItem={selectedAdminItem}
      />
      <AddCustomGroupModal
        showAddCustomGroupModal={showAddCustomGroupModal}
        handleCloseAddCustomGroupModal={handleCloseAddCustomGroupModal}
        selectedCustomCardId={selectedCustomCardId}
        selectedItem={selectedItem}
        disableInput={disableInput}
        approverGroupStaffList={approverGroupStaffList}
        setDropDown={setDropDown}
        dropDown={dropDown}
      />
    </>
  )
}

export default AdminAccessibility
